import { useFetcher, useLocation } from "@remix-run/react";

import { Button } from "@chakra-ui/react";

export function CheckoutButton({
  user,
  plan,
  children = `Subscribe to the ${plan} Plan`,
  returnTo,
  ...rest
}) {
  const location = useLocation();

  const fetcher = useFetcher();
  const isLoading = fetcher.state === "submitting";

  return (
    <Button
      isLoading={isLoading}
      onClick={() =>
        fetcher.submit(
          {
            plan, // must be 'flexible', 'unlimited', 'basic', or 'pro'
            returnTo: returnTo || location.pathname,
          },
          {
            action: `/api/stripe/checkout`,
            method: "POST",
          },
        )
      }
      {...rest}
    >
      {children}
    </Button>
  );
}
